import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {NavController} from "@ionic/angular";
import {SessionService} from "../services/session.service";
import {DataStore} from "@aws-amplify/datastore";
import {Ticket} from "../../models";

@Component({
    selector: "app-agent-support-chat",
    templateUrl: "./agent-support-chat.page.html",
    styleUrls: ["./agent-support-chat.page.scss"],
})
export class AgentSupportChatPage implements OnInit {
    ticketId;
    public title = "";

    constructor(
        private route: ActivatedRoute,
        public router: Router,
        private navController: NavController,
        public sessionService: SessionService
    ) {
    }

    async ngOnInit() {
        await this.route.params.subscribe(async (params) => {
            this.ticketId = params["ticketId"];
            this.title = (await DataStore.query(Ticket, params["ticketId"]))?.title;
        });
    }

    back() {
        this.navController.back();
    }

    openPage(page: string) {
        return this.router.navigate([page]);
    }
}
